
//  Link media
require.context('../media/', true, /^\.\/.*\.*/);
require.context('../fonts/', true, /^\.\/.*\.*/);

//  Styles
import '../styles/styles.scss';

// JS
import $ from 'jquery';

// Swiper JS
// import Swiper, { Navigation, Pagination } from 'swiper';
// // Swiper styles
// import 'swiper/swiper-bundle.min.css';
// import 'swiper/swiper.min.css';
// // configure Swiper to use modules
// Swiper.use([Navigation, Pagination]);

import utils from './proj/utils';
import handleLazySizes from './proj/handleLazySizes';
import handleContainSizing from './proj/handleContainSizing';
// import barba from '@barba/core';
// import Vivus from 'vivus';
// import shave from 'shave';

// import Lenis from '@studio-freight/lenis';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "../../gsap-extras/SplitText";
gsap.registerPlugin(ScrollTrigger, SplitText);


let Site;
const isMobileDevice = utils.mobileAndTabletCheck();
const isMobile = window.innerWidth < 800 || isMobileDevice;

(function ($) {
	'use strict';

	Site = {
		/**
		 * initialize prototype
		 *
		 */
		init: function (elt) {
			var self = this;

			// self.lazySizes();
			self.scrollToAnchor();
			self.toggleVideoEsc();
			self.initPages();
			// self.pageTransition();

			$('#app').addClass('page-ready');


			// const lenis = new Lenis()

			// lenis.on('scroll', (e) => {
			//   console.log(e)
			// })

			// function raf(time) {
			//   lenis.raf(time)
			//   requestAnimationFrame(raf);
			// }

			// requestAnimationFrame(raf);

			// window.addEventListener("resize", utils.debounce(function(e){
			// 	var maxHeight = $('.video__wrapper').outerHeight();
			// 	if($('.hero iframe').height() > maxHeight ) {
			// 		$('.hero iframe').height(maxHeight);
			// 	}
			// }));


			// https://codepen.io/GreenSock/pen/BaYGzvR
			
		},
		textAnimation: function(){

			var first_ever = true;

			gsap.set('.js-watch-btn', {opacity: 0});

			$('.st-line').each(function(){
				const elt = $(this);

				// for miscalcultation hide copy				
				gsap.set(elt, {opacity: 0});

				// tl_title.delay(delay_val); 
				ScrollTrigger.create({
					trigger: elt,
					scrub: true,
					anticipatePin: 1,
					// markers: true,
					start: "top 95%",
					once: true,
					onEnter: function(){
						// for miscalcultation show copy
						gsap.set(elt, {opacity: 1});

						let gsapChars = new SplitText(elt, { type: "lines,words,chars", linesClass: "lineChild" });

						const words = gsapChars.words;
						const chars = gsapChars.chars;


						var tl_title = gsap.timeline({paused: true});
						tl_title.from(words, {duration: 0.5, yPercent: 120, rotation: 5, ease: "power", stagger: 0.02})
							.add(function() {
								elt.addClass('played');
							});

						let delay_val = 0;
						if(elt[0].hasAttribute('data-delay')) {
							delay_val = $(this).attr('data-delay');
						}

						if(elt.hasClass('st-line--watchbtn')) {
							setTimeout(function(){
								gsap.to('.js-watch-btn', {opacity: 1, duration: 0.6});
								$('.js-watch-btn').addClass('is-animating');
							}, 600);
						}


						setTimeout(function(){
							tl_title.play();
						}, delay_val*1000)
					},
				});  

			});


			
			window.addEventListener("resize", utils.debounce(function(e){
				gsap.set('.played .lineChild', {'display': 'inline'});
			}));

		},
		initPages: function(){
			const self = this;

			// ONLY FOR LOCALHOST until script fixed // || location.hostname === "development.turnercommercialproductions.com"
			if (location.hostname === "localhost" || location.hostname === "127.0.0.1" ) {
				var barEl = document.getElementById('cnn-header');
				if(barEl) {
					self.navshare();
				}
			}

			self.popups();
			self.serieStickyMenu();
			document.fonts.ready.then(function () {
				self.textAnimation();
			});
			self.scrolltriggerAnimations();
			// self.imageSectionPlx();
			self.newWindowLink();
			// self.sliderSwipper();
			self.playLoop();
			self.countUpNumbers();

			if($('#videoPlayer').length > 0) {
				self.videoABversions()
				self.handleVideoSrc();
				self.playVideoIntro();
				self.toggleVideo();
			}


		},
		videoABversions: function(){
			function getRandomVersion() {
				const versions = [".version60", ".version30"];
				const randomIndex = Math.floor(Math.random() * versions.length);
				return versions[randomIndex];
			}

			var hide = getRandomVersion();
			if($(hide).length > 0) {
				$(hide).remove();
			}
		},
		popups: function(){
			var self = this;

			$('.js-open-popup').on('click', function() {
				var popup = $(this).attr('data-popup');
				$(popup).addClass('is-open');
				$('body').addClass('noscroll');
			});

			$('.js-popup-close').on('click', function() {
				$(this).parents('.popup').removeClass('is-open');
				$('body').removeClass('noscroll');
			});

			// press excap key to close menu too
			$(document).keyup(function(e) {
				if($('.popup.is-open').length > 0) {
					e.preventDefault();

					switch(e.which) {
						// case 37: // left
						// break;

						// case 39: // right
						// break;

						case 27: // esc
							$('.popup.is-open').find('.js-popup-close').trigger('click');
						break;

						default: return; // exit this handler for other keys
					}
				}
			});
		},

		pageTransition: function(){
			const self = this;
			
			barba.hooks.after((data) => {
				self.initPages();
			});


			const clipPathFromLeft = "polygon(0 0, 0 0, 0 100%, 0 100%)";
			const clipPathFromBottom = 'polygon(0 100%, 100% 100%, 100% 100%, 0 100%)';
			const clipPathFromTop = 'polygon(100% 0, 0 0, 0 0, 100% 0)';
			const clipPathFull = 'polygon(100% 0, 0 0, 0 100%, 100% 100%)';
			const easeAnimation = "power2.out";

			{}
			barba.init({
				transitions: [{
					name: 'default-transition',
					// sync: true,
					beforeLeave(data) {
						// gsap.set('.pageloader', {autoAlpha: '1', y: 0, x: 0, clipPath: clipPathFromLeft, webkitClipPath: clipPathFromLeft });
						gsap.set('.pageloader', {opacity: '0', x: 0 });
					},
					afterLeave() {
						$('#app').removeClass('page-ready');
						$(window).scrollTop(0); // scroll to top here
					},
					leave(data) {
						// return gsap.to('.pageloader', {clipPath: clipPathFull, webkitClipPath: clipPathFull, duration: 1.5, ease: easeAnimation});
						return gsap.to('.pageloader', {opacity: '1', duration: 0.5, ease: easeAnimation});
						// return gsap.to(data.current.container, {
						// 	opacity: 0
						// });
					},
					after(data) {
						return gsap.to('.pageloader', {opacity: '0', duration: 1.5, ease: easeAnimation, onComplete: () =>{
							$('#app').addClass('page-ready');
							ScrollTrigger.refresh(true);
							gsap.set('.pageloader', {opacity: '0', x: "-100%"});
						} });
						// return gsap.from(data.next.container, {
						// 	opacity: 0
						// });

					}
				}]
			});

		},

		// imageSectionPlx: function(){
		// 	if($('.mod-imageplx').length > 0 ){

		// 		const clipPathFull = 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)';
		// 		const clipPathFromBottom = 'polygon(0 100%, 100% 100%, 100% 100%, 0 100%)';
		// 		const easeAnimation = "power4.out";

		// 		gsap.set('.plx--2', {clipPath: clipPathFromBottom, webkitClipPath: clipPathFromBottom});

		// 		ScrollTrigger.create({
		// 			trigger: ".container-imageplx",
		// 			pin: '.mod-imageplx',
		// 			anticipatePin: 1,
		// 			// markers: true,
		// 			start: "top 30px",
		// 			end: "bottom top",
		// 			// end: "bottom+=1000px",
		// 			// pinSpacing: false,
		// 			// onEnter: function(){
		// 			// 	gsap.to('.plx2', { clipPath: clipPathFull, webkitClipPath: clipPathFull, ease: easeAnimation, duration: 3})
		// 			// }
		// 		});

		// 		const tl = gsap.timeline({
		// 			scrollTrigger: {
		// 				id: "clippath",
		// 				trigger: ".container-imageplx",
		// 				start: "top top",
		// 				end: "bottom bottom",
		// 				scrub: true
		// 			}
		// 		})
		// 		.to(".plx--2", { duration: 1, clipPath: clipPathFull, webkitClipPath: clipPathFull, ease: "none" })

		// 	}
		// },
		/**
		 * Sticky Section GENERIC
		 *
		 */
		scrolltriggerAnimations: function(){
			const self = this;

			// each paragraph of trigger
			// $('.js-wp-trigger').each(function(){

			// 	const target = '.'+$(this).attr('data-target');
			// 	const addClass = $(this).attr('data-class');
			// 	const offset = $(this).attr('data-offset');
			
			// 	const $trigger = $(this);

			// 	ScrollTrigger.create({
			// 		trigger: $trigger,
			// 		// markers: true,
			// 		start: "top "+offset,
			// 		onEnter: function($quote){
			// 			$(target).addClass( addClass );
			// 		},

			// 		onEnterBack: function($quote){ 

			// 		},

			// 		onLeave: function($quote){ 
		
			// 		},
			// 		onLeaveBack: function($quote){ 
			// 			$(target).removeClass( addClass );
			// 		},
			// 	});
			// });


			// 	ScrollTrigger matchMedia
			ScrollTrigger.saveStyles("");


			ScrollTrigger.matchMedia({
				'(min-width:768px)':function(){

					$(".end-cta").each(function(){
						const $el = $(this);

						ScrollTrigger.create({
							trigger: $el, 
							// markers: true,
							id: "inview",
							start: "top bottom",
							once: true,
							onEnter: function(){
								gsap.set('.end-cta-triangle-pink', {xPercent: 0});
								gsap.set('.end-cta-triangle-svg', {xPercent: 100});

								gsap.timeline().to('.end-cta-triangle-pink', {xPercent: -100, duration: 0.6 })
												.from('.end-cta-media', {x: '50%', duration: 0.6 }, '-=90%')
												.to('.end-cta-triangle-svg', {xPercent: 0, duration: 0.6 }, '-=95%')
												.from('.end-cta-clientlogo', {opacity: '0', duration: 0.6 }, '-=80%')
												.from('.end-cta-title__title', {opacity: '0', duration: 0.6 }, '-=80%')
												.from('.end-cta-title__ctas', {opacity: '0', duration: 0.6 }, '-=80%')
							}
						});
					});


					// more 
					// var container = document.querySelector('.js-more-serie');


					// ScrollTrigger.create({
					// 	trigger: '.more-articles',
					// 	pin: '.more-articles',
					// 	anticipatePin: true,
					// 	ease: "none",
					// 	// pinSpacing: false,
					// 	// invalidateOnRefresh: true,
					// 	// markers: true,
					// 	// id: "gallery",
					// 	scrub: 1,
					// 	start: "top top",
					// 	end: () => "+=" + container.offsetWidth,
					// 	// end: "bottom top",
					// 	animation: gsap.timeline()
					// 		.to(container, {
					// 			opacity: 1,
					// 			duration: 0.04,
					// 		})
					// 		.to(container, {
					// 			x: () => -(container.scrollWidth - document.documentElement.clientWidth) + "px",
					// 			duration: 1.2,
					// 		})
					// 		.to(container, {
					// 			opacity: 1,
					// 			duration: 0.04,
					// 		})
					// });

				},
				'(max-width:767px)':function(){
					
					$(".end-cta").each(function(){
						const $el = $(this);

						ScrollTrigger.create({
							trigger: $el, 
							// markers: true,
							id: "inview",
							start: "top bottom",
							once: true,
							onEnter: function(){
								// gsap.set('.end-cta-triangle-pink', {xPercent: 0});
								gsap.set('.end-cta-triangle-svg', {xPercent: 100});

								gsap.timeline()
												.from('.end-cta-clientlogo', {opacity: '0', duration: 0.6 })
												.from('.end-cta-title__title', {opacity: '0', duration: 0.6 }, '-=80%')
												.from('.end-cta-title__ctas', {opacity: '0', duration: 0.6 }, '-=80%')
												.to('.end-cta-triangle-svg', {xPercent: 0, duration: 0.6 }, '-=95%')
							}
						});
					});
							
				},
				// persistent for all breakpoints
				'all': function() {  

					$('.js-anim-children--fade').each(function(){
						var elts = $(this).children();

						gsap.set(elts, {y: 0, opacity: 0});

						ScrollTrigger.batch(elts, {
							// markers: true,
							start: "top 90%",
							onEnter: function(batch){  gsap.to(batch, {opacity: 1, y: 0, stagger: 0.45, duration: 0.6, overwrite: true})},
						});
					})

	                $(".js-play-lottie").each(function(){
						const $el = $(this);

						ScrollTrigger.create({
							trigger: $el, 
							// markers: true,
							id: "inview",
							start: "top bottom",
							onEnter: function(){
								if (!$el.hasClass('is-inview')) {
									$el.addClass('is-inview');
									$el.find('lottie-player').get(0).stop();
	                                $el.find('lottie-player').get(0).play();
								}
							}, 
							onLeave: function(){
								if (!$el.hasClass('is-inview')) {
									$el.removeClass('is-inview');
									$el.find('lottie-player').get(0).stop();
								}
							}
						});
					});

					$("[class*='ivanim-']").each(function(){
						const $el = $(this);

						ScrollTrigger.create({
							trigger: $el, 
							// markers: true,
							id: "inview",
							start: "top bottom",
							onEnter: function(){
								if (!$el.hasClass('is-inview')) {
									$el.addClass('is-inview');
								}
							}
						});
					});
					// inview repeat
					$("[class*='ivanimr-']").each(function(){
						const $el = $(this);

						ScrollTrigger.create({
							trigger: $el, 
							// markers: true,
							start: "top bottom",
							onEnter: function(){
								if (!$el.hasClass('is-inview')) {
									$el.addClass('is-inview');
								}
							},
							onLeave: function(){ 
								// if ($el.hasClass('is-inview')) {
								// 	$el.removeClass('is-inview');
								// }
							},
							onEnterBack: function(){ 
								// if (!$el.hasClass('is-inview')) {
								// 	$el.addClass('is-inview');
								// }
							},
							onLeaveBack: function(){ 
								if ($el.hasClass('is-inview')) {
									$el.removeClass('is-inview');
								}
							},
						});
					});
				}
			})


		},


		serieStickyMenu: function(){

			var $menubutton = $('.js-main-menu-toggle');
			
			$menubutton.on('click', function(){
				$menubutton.toggleClass('is-active');
				if($menubutton.hasClass('is-active')) {
					$('body').addClass('noscroll menu-open');


					var listElts = '.article-list li'
					gsap.set(listElts, {y: 20, opacity: 0});

					gsap.timeline()
						.to('.article-list', {opacity: 1, duration: 0.9})
						.to(listElts , {y: 0, opacity: 1, stagger: 0.1, duration: 0.5})
				}
				else {
					$('body').removeClass('noscroll menu-open');
				}
			});
			$('.aside-more-series a').on('click', function(){
				$menubutton.removeClass('is-active');
				$('body').removeClass('noscroll menu-open');
			});

			// press excap key to close menu too
			$(document).keyup(function(e) {
				if (e.key === "Escape") { // escape key maps to keycode `27`
					if($('body').hasClass('menu-open')) {
						$menubutton.eq(0).trigger('click');
					}
				}
			});

			// ScrollTrigger.create({
			// 	trigger: '.menu-serie-sticky',
			// 	pin: '.toggleMenu-container',
			// 	pinSpacing: false,
			// 	start: "top top",
			// 	// end: "bottom bottom",
			// 	// animation: gsap.to($(panel).find('img'), { y: '20%' })
			// });
		},
		playVideoIntro: function(){

			const playVideo = function(vid) {

				var playPromise = vid.play();

				if (playPromise !== undefined) {
					playPromise.then(function() {
						// Automatic playback started!
					}).catch(function(error) {
						vid.muted = true;
						vid.play();
						// Automatic playback failed.
						// Show a UI element to let the user manually start playback.
					});
				}
			};
			const pauseVideo = function(vid) {
				vid.pause();
			};

			//reset video to start
			var v = document.getElementById('videoPlayer');


			playVideo(v);
			// console.log('===  main.js [185] ===', v);
			
			ScrollTrigger.create({
				trigger: '.hero',
				onLeave: function(){
					pauseVideo(v);
				},
				onEnter: function(){
					// playVideo(v);
				},
				onEnterBack: function(){
					playVideo(v);
				},
				onLeaveBack: function(){
					// pauseVideo(v);
				},
				// markers: true,
				// id: 'hero-cte',
				start: "top -60px",
				// end: "bottom 50%",
			});


		},

		playLoop: function(){

			const playVideo = function(vid) {

				var playPromise = vid.play();

				if (playPromise !== undefined) {
					playPromise.then(function() {
						// Automatic playback started!
					}).catch(function(error) {
						vid.muted = true;
						vid.play();
						// Automatic playback failed.
						// Show a UI element to let the user manually start playback.
					});
				}
			};
			const pauseVideo = function(vid) {
				vid.pause();
			};

			// console.log('===  main.js [185] ===', v);

			$('.js-videoloop').each(function(){

				var elt = $(this);
				gsap.set(elt, {scale: 1.05});

				var l1 = $(this).attr('data-l1');
				var l2 = $(this).attr('data-l2');

				var trigger_elt = $(this);
				var v = $(this).find('video').get(0);

				ScrollTrigger.create({
					trigger: trigger_elt,
					scrub: true,
					// markers: true,
					animation: gsap.timeline().to(l1, { xPercent: 20, duration: 1 }).to(l2, { xPercent: -20, duration: 1 }, '<'),
					onLeave: function(){
						pauseVideo(v);
					},
					onEnter: function(){
						playVideo(v);
						gsap.to(elt, { scale: 1, duration: 0.8 });
					},
					onEnterBack: function(){
						playVideo(v);
					},
					onLeaveBack: function(){
						gsap.to(elt, { scale: 1.05, duration: 0.8 });
						pauseVideo(v);
					},
					// markers: true,
					// id: 'hero-cte',
					start: "top bottom",
					end: "bottom top",
				});

			});

			$('.js-imageloop').each(function(){

				var elt = $(this);
				var elt_image = $(this).find('.header-image img');
				gsap.set(elt, {scale: 1.05});

				var l1 = $(this).attr('data-l1');
				
				var xPercent_val = 20;
				// if($(this).attr('data-percent')) {
				// 	xPercent_val = parseInt($(this).attr('data-percent'));
				// }

				var trigger_elt = $(this);

				ScrollTrigger.create({
					trigger: trigger_elt,
					scrub: true,
					// markers: true,
					// animation: gsap.timeline().to(l1, { xPercent: -xPercent_val, duration: 1 }).to(elt_image, { scale: 1.1, duration: 1 }, '<'),
					animation: gsap.timeline().to(l1, { xPercent: -20, duration: 1 }),
					onLeave: function(){
					},
					onEnter: function(){
						gsap.to(elt, { scale: 1, duration: 0.8 });
					},
					onEnterBack: function(){
					},
					onLeaveBack: function(){
						gsap.to(elt, { scale: 1.05, duration: 0.8 });
					},
					// markers: true,
					// id: 'hero-cte',
					start: "top bottom",
					end: "bottom top",
				});

			})

			$('.js-imageloop-2lines').each(function(){

				var elt = $(this);
				var elt_image = $(this).find('.header-image img');
				gsap.set(elt, {scale: 1.05});

				var l1 = $(this).attr('data-l1');
				var l2 = $(this).attr('data-l2');
				
				var xPercent_val = 20;
				// if($(this).attr('data-percent')) {
				// 	xPercent_val = parseInt($(this).attr('data-percent'));
				// }

				var trigger_elt = $(this);

				ScrollTrigger.create({
					trigger: trigger_elt,
					scrub: true,
					// markers: true,
					// animation: gsap.timeline().to(l1, { xPercent: -xPercent_val, duration: 1 }).to(elt_image, { scale: 1.1, duration: 1 }, '<'),
					animation: gsap.timeline().to(l1, { xPercent: 20, duration: 1 }).to(l2, { xPercent: -20, duration: 1 }, '<'),
					onLeave: function(){
					},
					onEnter: function(){
						gsap.to(elt, { scale: 1, duration: 0.8 });
					},
					onEnterBack: function(){
					},
					onLeaveBack: function(){
						gsap.to(elt, { scale: 1.05, duration: 0.8 });
					},
					// markers: true,
					// id: 'hero-cte',
					start: "top bottom",
					end: "bottom top",
				});

			})

		},



		countUpNumbers: function (section) {
			function numberWithCommas(x) {
				return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			}
		
			function animateState(el){
				const count = $(el);
				const comma = $(el).data('comma') || true;
				const countUpDuration = $(el).attr('data-duration') || 1;
		
				gsap.to(count, {
					innerText: count.attr("data-number"),
					snap: {innerText: 1},
					stagger: {
						each: 1.0,
						onUpdate: function() {
							if(comma) {
								this.targets()[0].innerHTML = numberWithCommas(Math.ceil(this.targets()[0].innerText));
							}
						},
					},
					duration: countUpDuration
				});
		
			}
	
			$('.js-stat-number').each(function(el){

				const $el = $(this);

				ScrollTrigger.create({
					trigger: $el, 
					// markers: true,
					id: "inview",
					start: "top 95%",
					once: true,
					onEnter: function(){
						$('.js-stat-number').html(0);
						animateState($el);
						// if (!$el.hasClass('is-inview')) {
							// $el.addClass('is-inview');
						// }
					},
					// onEnterBack: function(){
					// 	$('.js-stat-number').html(0);
					// 	animateState($el);
					// }
				});
				
			});
		
		},

		toggleVideoEsc: function(){
			$(document).keyup(function(e){
				switch(e.which) {
					case 27: // esc
						if($('.hero .video').hasClass('is-open')) {
							$('.video .js-toggle-video').trigger('click');
						}
					break;
					default: return; // exit this handler for other keys
				}

			});
		},
		toggleVideo: function(){

			const self = this;

			// var iframe = document.querySelector('iframe');


				// self.loadVideoTracking(iframe);
				var iframe;
				var player;

				$('.js-toggle-video').on('click', function(){

					if($('.mod-popup--video').hasClass('is-open')) {
						iframe = $('.mod-popup-video iframe:visible');
						player = new Vimeo.Player(iframe.get(0));
					}

					if(iframe.length > 0) {
						if($('.mod-popup--video').hasClass('is-open')) {
							player.play();
						}
						else {
							player.pause()
						}
					}
				});

			// player
			// ScrollTrigger.create({
			// 	trigger: '.hero .video',
			// 	scrub: true,
			// 	// markers: true,
			// 	start: "top top",
			// 	end: "+="+($('.hero .video').height() - 120),
			// 	onLeave: function(){
			// 		if($('.hero .video').hasClass('is-open')) {
			// 			player.pause()
			// 		}
			// 	},
			// 	onEnterBack: function(){
			// 		if($('.hero .video').hasClass('is-open')) {
			// 			player.play()
			// 		}
			// 	},
			// });

		},

		/**
		 * video replace
		 *
		 */
		handleVideoSrc: function() {

			const updateVideoSrc = function(vid) {
				const src = vid.getAttribute('data-vid-src');
				// const newSrc = (isMobile) ? src.replace(".mp4", "-mob.mp4") : src;
				const newSrc = src;
				const hasPoster = vid.getAttribute('data-hasposter');
				if (hasPoster) {
					vid.setAttribute('poster', (isMobile) ? hasPoster + '-mob.jpg' : hasPoster + '.jpg');
				}
				vid.setAttribute('src', newSrc);
			};

			const vids = document.querySelectorAll("video[data-vid-src]");
			[...vids].forEach( updateVideoSrc );

			
		},
		// sliderSwipper: function(){
		// 	const swiper = new Swiper('.more-series__inner', {
		// 		// Default parameters
		// 		slidesPerView: "auto",
		// 		spaceBetween: 0,
		// 		freeMode: true,
		// 		// keyboard: {
		// 		// 	enabled: true,
		// 		// 	onlyInViewport: false,
		// 		// },
		// 		// freeMode: {
		// 		// 	enabled: true,
		// 		// 	sticky: true,
		// 		// },
		// 		// scrollbar: {
		// 		// 	el: '.swiper-scrollbar',
		// 		// 	draggable: true,
		// 		// },
		// 		// simulateTouch: true,
		// 		pagination: {
		// 			el: '.swiper-pagination',
		// 			type: 'bullets',
		// 			clickable: true,
		// 		},
		// 		// Responsive breakpoints
		// 		// breakpoints: {
		// 		// 	// when window width is >= 320px
		// 		// 	320: {
		// 		// 		slidesPerView: 1.5,
		// 		// 	},
		// 		// 	500: {
		// 		// 		slidesPerView: 2.2,
		// 		// 	},
		// 		// 	768: {
		// 		// 		slidesPerView: 3.1,
		// 		// 	},
		// 		// 	1024: {
		// 		// 		slidesPerView: 3.5,
		// 		// 	},
		// 		// 	1300: {
		// 		// 		slidesPerView: 4,
		// 		// 	}
		// 		// }
		// 	})

		// },

		navshare: function(){
			const self = this;
			// Setup social share menu
			var barEl = document.getElementById('cnn-header');
			var shareEl = barEl.querySelector('[data-share]');
			var shareToggleEl = barEl.querySelector('[data-share-toggle]');

			if(shareToggleEl) {
				shareToggleEl.addEventListener('click', function(){
					if(shareEl.classList.contains('cnn-header__share--active')){
						shareEl.classList.remove('cnn-header__share--active');
					} else {
						shareEl.classList.add('cnn-header__share--active');
					}
				}, false);
			}

			// Set up scroll handler
			document.addEventListener('scroll', function() {
				window.requestAnimationFrame(self.onScroll);
			}, {passive: true});

		},
		onScroll: function(){
			// Get current scroll position
			var sPos = typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY;

			var barEl = document.getElementById('cnn-header');
			if(sPos < 30) {
				if($('.cnn-header__row--gold').hasClass('cnn-header__row--sticky')) {
					$('.cnn-header__row--gold').removeClass('cnn-header__row--sticky');
				}
			} else {
				// if(!barEl.classList.contains('cnn-header--fixed')) {
				// 	barEl.classList.add('cnn-header--fixed');
				// }
				if(!$('.cnn-header__row--gold').hasClass('cnn-header__row--sticky')) {
					$('.cnn-header__row--gold').addClass('cnn-header__row--sticky');
				}
			}
		},


		/**
		 * Scroll to
		 *
		 */
		scrollToAnchor: function () {
			// const ft_nav_height = $('#ft-fixed-nav-height').height();

			$('body').on('click', '.scrollTo', function(event){
				event.preventDefault();
				event.stopPropagation();

				var tag = $(this).attr('href');

				$('html,body').animate({scrollTop: $(tag).offset().top },'slow');
			});
		},

		/**
		 * Open links in new window
		 *
		 */
		newWindowLink: function () {
			$('p a[href]').not('.goto').each(function() {
				// if(!$(this).attr('href').indexOf('cnn') != -1) {
					$(this).attr('target','_blank');
				// }
			});
		},

		/**
		 * Image lazy sizes
		 *
		 */
		lazySizes: function(){
			handleLazySizes( this.onImageLoaded.bind(this) );
		},
		

		/**
		 * CNN video view trackers
		 *
		 */
		loadVideoTracking: function($iFrame){

			// var iframe = document.querySelector('iframe');
			// video2
			// document.querySelector("#discover > div:nth-child(3) > div > div > iframe");
			// video1
			// document.querySelector("#explore > div:nth-child(3) > div > div > iframe");
			// Marsalis
			// document.querySelector("#mission > div:nth-child(5) > div:nth-child(3) > div:nth-child(3) > div > iframe");
			// Wells
			// document.querySelector("#mission > div:nth-child(5) > div:nth-child(3) > div:nth-child(1) > div > iframe");
			// Silverstein
			// document.querySelector("#mission > div:nth-child(5) > div:nth-child(2) > div:nth-child(3) > div > iframe");
			// pink
			// document.querySelector("#mission > div:nth-child(5) > div:nth-child(2) > div:nth-child(1) > div > iframe");
			var player = new Vimeo.Player($iFrame);
			// var title = '211112_EVOLVE_3MIN_FIN_LP';
			// var title = player.getVideoTitle();
			// var url = '645244292';
			var playedVideoTrackingFlag = true;
			var startPlayedVideoTrackingFlag = true;

			player.getVideoTitle().then(function(title) {
				console.log('title:', title);
		
				function playedVideoTracking(title) {
					s.events = 'event32';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					s.tl(true, 'o', 'cnnadfeaturevideo:play');
					s.events = s.prop29 = s.eVar41 = '';
				}
			
				function startPlayedVideoTracking(title) {
					s.events = 'event32';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					s.tl(true, 'o', 'cnnadfeaturevideo:milestone');
					s.events = s.prop29 = s.eVar41 = '';
				}
			
				function tenPlayedVideoTracking(title) {
					s.events = 'event40,event36';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					// s.products = ';;;;event36=' + data.seconds;
					s.tl(true, 'o', 'cnnadfeaturevideo:milestone - video 10% complete');
					s.events = s.prop29 = s.eVar41 = s.products = '';
				}
			
				function twentyFivePlayedVideoTracking(title) {
					s.events = 'event41,event36';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					// s.products = ';;;;event36=' + data.seconds;
					s.tl(true, 'o', 'cnnadfeaturevideo:milestone - video 25% complete');
					s.events = s.prop29 = s.eVar41 = s.products = '';
				}
			
				function fiftyPlayedVideoTracking(title) {
					s.events = 'event2,event36';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					// s.products = ';;;;event36=' + data.seconds;
					s.tl(true, 'o', 'cnnadfeaturevideo:milestone - video 50% complete');
					s.events = s.prop29 = s.eVar41 = s.products = '';
				}
			
				function seventyFivePlayedVideoTracking(title) {
					s.events = 'event42,event36';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					// s.products = ';;;;event36=' + data.seconds;
					s.tl(true, 'o', 'cnnadfeaturevideo:milestone - video 75% complete');
					s.events = s.prop29 = s.eVar41 = s.products = '';
				}
			
				function endVideoTracking(title) {
					s.events = 'event33,event36';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					// s.products = ';;;;event36=' + data.seconds;
					s.tl(true, 'o', 'cnnadfeaturevideo:complete');
					s.events = s.prop29 = s.eVar41 = s.products = '';
				}
			
				player.on('play', function() {
					playedVideoTracking(title);
					// playedVideoTrackingFlag = false;
					console.log('Played the video');
				});
			
			
				var loopCount = 0;
				var tenPlayedVideoTrackingFlag = true;
				var twentyFivePlayedVideoTrackinggFlag = true;
				var fiftyPlayedVideoTrackingFlag = true;
				var seventyFivePlayedVideoTrackingFlag = true;
				var endVideoTrackingFlag = true;
			
				player.on('timeupdate', function(data) {
					// console.log(data.duration);
					// console.log(data.percent);
					// console.log(data.seconds);
			
					// if (data.percent == 0.003 && loopCount == 0) {
					//   startPlayedVideoTracking(title + ' - video start');
						// tenPlayedVideoTrackingFlag = false;
					//   console.log('Played Start');
					// }
					// var iNum = data.percent;
					var TOLERANCE = 0.001
					
					if (data.percent == 0.1  && loopCount == 0) {
						tenPlayedVideoTracking(title);
						// tenPlayedVideoTrackingFlag = false;
						console.log('Played 10%');
					}
					if (data.percent == 0.25 && loopCount == 0) {
						twentyFivePlayedVideoTracking(title);
						// twentyFivePlayedVideoTrackingFlag = false;
						console.log('Played 25%');
					}
					if (data.percent == 0.50 && loopCount == 0) {
						fiftyPlayedVideoTracking(title);
						// fiftyPlayedVideoTrackingFlag = false;
						console.log('Played 50%');
					}
					if (data.percent == 0.75 && loopCount == 0) {
						seventyFivePlayedVideoTracking(title);
						// seventyFivePlayedVideoTrackingFlag = false;
						console.log('Played 75%');
					}
					if ((data.percent >= (0.99 - TOLERANCE) && data.percent <= (0.99 + TOLERANCE)) && loopCount == 0) {
						endVideoTracking(title);
						loopCount += 1;
						// endVideoTrackingFlag = false;
						console.log('Completed');
					}
				});
			});

		},


	};


	$(document).ready( function(){
		Site.init();
	})

})(jQuery);



// WEBPACK FOOTER //
// ./src/js/main.js